export const StrategicVolumeReportRelease = {
    NOT_RELEASED: 0,
    READY_FOR_RELEASE: 1,
    RELEASED: 2,
};
